export default __webpack_public_path__ + "static/media/sec-esp-cult-white.ab7162cf.svg";